/**
 * 로컬 스토리지 유틸리티
 * 타입 안전성과 에러 핸들링을 제공
 */

/**
 * 로컬 스토리지에 JSON 데이터 저장
 */
export const setItem = <T>(key: string, value: T): void => {
    try {
        const serialized = JSON.stringify(value);
        localStorage.setItem(key, serialized);
    } catch (error) {
        console.error(`[Storage] Failed to save ${key}:`, error);
    }
};

/**
 * 로컬 스토리지에서 JSON 데이터 가져오기
 */
export const getItem = <T>(key: string): T | null => {
    try {
        const serialized = localStorage.getItem(key);
        if (serialized === null) {
            return null;
        }
        return JSON.parse(serialized) as T;
    } catch (error) {
        console.error(`[Storage] Failed to load ${key}:`, error);
        return null;
    }
};

/**
 * 로컬 스토리지에서 항목 삭제
 */
export const removeItem = (key: string): void => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        console.error(`[Storage] Failed to remove ${key}:`, error);
    }
};

/**
 * 로컬 스토리지 전체 삭제
 */
export const clear = (): void => {
    try {
        localStorage.clear();
    } catch (error) {
        console.error('[Storage] Failed to clear storage:', error);
    }
};

/**
 * 스토리지 키 상수
 * 백엔드 세션 관리와 연동되는 키들
 */
export const STORAGE_KEYS = {
    SESSION_ID: 'sessionId',
    REFRESH_TOKEN: 'refreshToken',
    ACCESS_TOKEN: 'accessToken',
    CURRENT_CENTER_ID: 'currentCenterId',
    CSRF_TOKEN: 'csrfToken',
    USER_INFO: 'userInfo',
    REMEMBER_ME: 'rememberMe',
} as const;
